'use client';

import type { LabelHTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  hideRequiredIndicator?: boolean;
  helperText?: ReactNode;
}

export function Label({
  className,
  children,
  required,
  hideRequiredIndicator = false,
  helperText,
  ...rest
}: LabelProps) {
  return (
    <div className="flex w-full flex-col gap-1.5">
      <label {...rest} className={cx('inline-flex items-center gap-1 text-sm font-medium text-secondary', className)}>
        <span>{children}</span>
        {required && !hideRequiredIndicator ? (
          <span aria-hidden="true" className="text-danger">
            *
          </span>
        ) : null}
      </label>

      {helperText ? <span className="text-xs leading-5 text-tertiary">{helperText}</span> : null}
    </div>
  );
}

Label.displayName = 'Label';
